import { AdminClientAnketas } from './AdminClientAnketas';

export default AdminClientAnketas;